import TwoColumnsSection from "./TwoColumnsSection";

export default TwoColumnsSection;
